import React, { useRef, useEffect } from "react"
import { Box } from "theme-ui"
import gsap from "gsap"

const blocks = [
  { s: "#left-top", x: "-100px", y: "-30px", d1: 8, d2: 6 },
  { s: "#left-bottom", x: "-40px", y: "-80px", d1: 8, d2: 6 },
  { s: "#right-top", x: "0px", y: "100px", d1: 10, d2: 6 },
  { s: "#right-right", x: "-100px", y: "-100px", d1: 12, d2: 8 },
  { s: "#right-bottom", x: "-70px", y: "-100px", d1: 10, d2: 7 },
  { s: "#right-left", x: "0px", y: "70px", d1: 11, d2: 9 },
]

const dots = [
  { s: "#dot-1", d1: 1, d2: 2, delay: "-1" },
  { s: "#dot-8", d1: 1, d2: 2, delay: "1" },
  { s: "#dot-2", d1: 1, d2: 2, delay: "3.7" },
  { s: "#dot-7", d1: 1, d2: 4, delay: "5" },
  { s: "#dot-3", d1: 1, d2: 2, delay: "8" },
  { s: "#dot-6", d1: 1, d2: 2, delay: "2" },
  { s: "#dot-4", d1: 1, d2: 2, delay: "1" },
  { s: "#dot-5", d1: 1, d2: 2, delay: ".4" },
  { s: "#dot-9", d1: 1, d2: 2, delay: "8" },
]

const AnimateOne = () => {
  useEffect(() => {
    blocks.forEach(({ s, x, y, d1, d2 }) => {
      let blockTimeline = gsap.timeline({ repeat: -1 })
      blockTimeline
        .to(s, { transform: `translate3d(0, 0, 0)` })
        .to(s, { transform: `translate3d(${x}, ${y}, 0)`, duration: d1 })
        .to(s, { transform: "translate3d(0, 0, 0)", duration: d2 })
    })

    let brain = gsap.timeline({ repeat: -1, repeatDelay: 5 })
    brain
      .to("#brain-dot", { opacity: 0 })
      .to("#brain-dot", { opacity: 1 })
      .to("#brain-dot", {
        opacity: 0,
        transform: "translateX(450px)",
        duration: 3,
      })

    let master = gsap.timeline()

    dots.forEach(({ s }) => {
      let wordTimeline = gsap.timeline()
      wordTimeline.to(s, { opacity: 0 }).to(s, { opacity: 1, duration: 0.5 })
      // .to(s, { opacity: 0, duration: 1, delay: 3 })
      master.add(wordTimeline)
    })
  }, [])
  return (
    <Box
      as="svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1366 517.92"
      sx={{
        width: ["150%", "100%"],
        "#assigned-dots g": {
          opacity: 0,
        },
        "#unassigned-dots circle": {
          opacity: 0,
        },
        ".text-class": {
          fontSize: "15px",
          fontWeight: "bold",
          lineHeight: 1.6,
          fill: "#333",
          fontFamily: "Manrope, Helvetica, sans-serif",
        },
        ".blue-circle": {
          fill: "#fff",
          stroke: "#e61515",
          strokeWidth: 1,
        },
        ".blue-bg": {
          isolation: "isolate",
          fill: "#56b9e9",
          opacity: 0.18,
        },
        ".gray-bg": {
          fill: "#dedede",
          opacity: "0.25",
          isolation: "isolate",
        },
      }}
    >
      <g id="backdrop">
        <path
          id="poly1"
          className="gray-bg"
          d="M0 68l37.93-30.14 89.82 82.43 114.49-14.87-92 115.63 129.12-51.7-62.1 260.56-21.52-154.25-115.8 61-42.41-128.47L0 272.94V68z"
        />
        <path
          id="poly2"
          className="gray-bg"
          d="M148 345.75L295.85 211.5l134.74-52.19 63.62 52.19 74.86-42.1L672 193.21l92.3 125.12-229.21 8.75-119.47-68.9L294 355.5z"
        />
        <path
          id="left-top"
          className="blue-bg"
          d="M136.9 67l59.31-16.41-11.94 31.53z"
        />
        <path
          id="left-bottom"
          className="blue-bg"
          d="M24.68 362.2l93.49-29.83-20.34 43.25-60.75 11.94z"
        />
        <path
          id="right-left"
          className="blue-bg"
          d="M430.11 306.38v39.36l28.25-.92z"
        />
        <path
          id="right-right"
          className="blue-bg"
          d="M648.28 238.19l-22.14 17.71 19.93 39.87 8.86-26.58z"
        />
        <path
          id="right-bottom"
          className="blue-bg"
          d="M512.94 288.41l31-15.51 8.85 26.58-19.93 37.65 2.22-35.44-70.87 19.94z"
        />
        <path
          id="right-top"
          className="blue-bg"
          d="M523.93 94.64L479 127.86l26.87 5.35 34-30.48z"
        />
      </g>
      <g id="lines" fill="none" stroke="#e61515" strokeWidth=".71">
        <path
          d="M952.2 225.25h-13.13c-1.07.19-6.08 6.83-6.68 7.72s-.46 2.22-.39 3.36a15.25 15.25 0 01-12.28 15.49c-.57 2.21 2.14 4 2.25 6.28.11 2.56-2.89 4-5.35 4.66l-5.13 1.48c-1.23.35-2.7 1-2.77 2.27a3.27 3.27 0 00.6 1.7c.94 1.63 1.83 3.45 1.57 5.32s-2.24 3.57-4 2.86-3.38.12-3.28-1.84l.93-3.19c1-2.67-.79-5.65-3.1-7.32s-5.11-2.53-7.5-4.08a2.85 2.85 0 01-1-.93 2.17 2.17 0 011.09-2.76 6.41 6.41 0 013.23-.45l10.71.39c3.07.11 6.91-.27 8-3.14s-2-6-5.1-6.54c-8.5-1.57-16.21 7.45-24.76 6.12-2.21-.35-4.35-1.39-6.59-1.24-1.91.13-3.64 1.11-5.42 1.79-5 1.9-10.51 1.5-15.83 1.07-2.64-.22-5.45-.5-7.51-2.16a6.62 6.62 0 016.48-11.34 11.81 11.81 0 01-3.81 6 5.77 5.77 0 007.2-2.68 34.44 34.44 0 011.34-3.38c.64-1 2.08-1.76 3.07-1.06.26 1.79-1.1 3.43-1.26 5.25-.29 3.36 3.94 5.69 7.18 4.73s5.42-4 7-6.94a12.6 12.6 0 012.62-3.83c2.43-2.07 6-1.69 9.18-1.18a2.31 2.31 0 011.39.54c.92.95-.2 2.43-1.13 3.37s-1.5 2.9-.23 3.26c1.8.82 3.92.17 5.64-.81s3.26-2.29 5.14-2.89c4.6-1.49 9.29 1.61 14 2.42A15.15 15.15 0 00926 241a3.31 3.31 0 001.06-1.08c.64-1.21-.28-2.75-1.5-3.36a12.05 12.05 0 00-4-.76 15.65 15.65 0 01-10.32-5.67 3.71 3.71 0 01-1.06-3.07 2.71 2.71 0 012.75-1.78 6.4 6.4 0 013.23 1.28 19.71 19.71 0 014 3.64c.89 1.06 1.76 2.28 3.08 2.71 2.7.89 5.09-2 6.44-4.46 1.22-2.27 2.39-4.71 2.32-7.3s-1.81-5.3-4.37-5.61a2.78 2.78 0 00-2.56.9c-.87 1.13-.35 2.76-.69 4.15-.74 3-5.26 3.4-7.77 1.54s-3.77-4.94-5.67-7.42a16.68 16.68 0 00-8.72-5.86 3.94 3.94 0 00-3.46.27c-1.28 1-1.08 2.95-.8 4.55.75 4.19 1.18 8.8-1 12.43-2.83 4.61-9 6-14.41 5.19-2.21-.33-4.39-.95-6.63-1.06-10.58-.56-19.67 9.9-30.17 8.47a21.4 21.4 0 01-6.87-2.41c-3.8-2-7.52-4.67-9.07-8.65s0-9.37 4.08-10.68a3.61 3.61 0 012.9.16c2.42 1.47 1.18 6 3.71 7.31a4.45 4.45 0 002.73.17c3.61-.59 7.48-2.07 9.1-5.35a20.13 20.13 0 001.29-5.51c.34-1.86 1-3.82 2.58-4.89s4.17-.67 4.75 1.14a4.28 4.28 0 01-.69 3.31c-1.42 2.58-3.46 5-3.69 7.93-.35 4.41 4.34 8.36 8.67 7.47s7.09-6.11 5.62-10.28c-.71-2-2.21-3.7-2.7-5.78-.74-3.13 1-6.39 3.45-8.49a4.09 4.09 0 012.75-1.24c2.09.09 3.06 2.81 2.57 4.85s-1.82 3.8-2.23 5.85c-.91 4.48 3.31 8.91 7.87 9.15s8.81-2.92 11-6.94a9 9 0 001.22-4.95 4.76 4.76 0 00-2.8-4 1.81 1.81 0 00-2.29.57 3 3 0 00-.08 1.5c.13 2-1.57 4.17-3.55 3.87a3.57 3.57 0 01-2.72-3c-.67-3.88 3.2-7.1 7-8.21s7.95-1.12 11.34-3.14c2.81-.72 5.57 1.25 7.82 3a8.52 8.52 0 011.81 2.42 22.22 22.22 0 0010.68 9.06c1.15.45 2.82.6 3.29-.53a2.31 2.31 0 00.06-1.25c-1-6.38-7.35-10.22-11.85-14.87-1.75-1.81-3.29-3.85-5.1-5.62-4.07-4-6.9-6.15-12.58-6.74 3.44 2.95.1 8.55-3.3 11.55s-8.48 3.37-12.86 2.19a5.68 5.68 0 013.86-4.84c2.49-.79 5.49.19 7.66-1.28a4.14 4.14 0 00-.32-6.71 1.51 1.51 0 00-.71-.22c-.85 0-1.23 1-1.57 1.8a3.77 3.77 0 01-2.91 2.39c-1.31.1-2.69-1.12-2.4-2.4.54-2.36 5.2-2.28 5-4.68a2.3 2.3 0 00-1-1.5c-1.9-1.4-4.5-1.11-6.83-.76l-9.17 1.39c-1.73.26-3.89 1-4 2.72-.08 1.52 1.55 2.52 3 3s3.15 1 3.73 2.37a3.64 3.64 0 01-.34 3c-2.33 4.74-8.38 6-13.61 6.65a7.15 7.15 0 00-2.67.71c-2.65 1.52-2.37 5.59-4.48 7.79a4.53 4.53 0 01-7.42-5 8.37 8.37 0 012.43-2.87c4.78-4.06 7-5.54 12.83-7.76 1.14-.44 2.54-2.21 3.3-3.16 1.36-1.71.33-3.14-1.52-4.3a6.8 6.8 0 00-6.27-.06 24.24 24.24 0 00-5.32 3.77c-5.79 4.84-8.93 7.15-14.36 12.4s-11.6 9.84-12 17.38c0 0 1.79 7.4-13.06 7.4"
          strokeLinejoin="round"
          strokeDasharray="1052.96 1054.38"
        />
        <path
          id="line1"
          d="M.25 68.45c46.45 12.83 55.32 31.19 66.68 106.9 3.44 22.88 45.22 96.58 67.86 87.7 27.76-10.87 98.55-38.83 127.72-24 52 26.5 146.24 91.5 146.24 91.5s89.31-89.7 223.37-45.07c17.85 5.94 35.71 6.09 52.77-2.72 32-16.47 45.21-56.52 86.25-56.52"
          strokeDasharray="959.05 960.47"
          strokeMiterlimit="7.11"
        />
        <path
          d="M.25 227.42c36.43 4.39 78.11-10 113.46-16.57 38.2-7.1 69.25-113.16 90.57-113.16 35.43 0 18.41 90.18 30.91 108.75 24.3 36.08 125 0 180.29-30.7 58.73-32.62 110.49-.59 173.64 16.76 58.2 16 39.55 32.79 101.41 35.35"
          strokeDasharray="867.27 868.69"
          strokeMiterlimit="7.11"
        />
        <path
          d="M.25 441.23q36.2-23.58 72-47.74c41.31-27.82 80.54-63 122.83-88.49 23.25-14 33.66-4.18 49.09 12.81 1.88 2.07 27.37 31.47 28.52 30.63 30.22-21.88 21.83-167.29 49.47-160.1 68.19 17.76 154 29.31 240.39 35.12 82.16 5.53 164.93 5.88 233.74 1.44h15.24"
          strokeDasharray="1003.87 1005.29"
          strokeMiterlimit="7.11"
        />
        <path
          d="M.25 328.62L76.78 286a18.5 18.5 0 0125.39 7.63c19 36.51 50.71 80.26 94.69 64.38 41.19-14.87 51.25-64.6 97.54-72.3 14.76-2.46 29.87-.72 44.83-1.21 43.67-1.41 130.35-24 137.31-78.31 2.35-18.41 15.09-37.95 28.38-50.89 7.32-7.14 15.68-14.24 24.8-19 5.58-2.9 12.48-4.29 18.12-1.53 5.48 2.68 8.56 8.53 10.88 14.17 5.77 14.05 8.6 29.4 12.49 44.07q6.42 24.28 13.12 48.5c10.32 37.38 21.24 74.57 32.35 111.72a21.49 21.49 0 002.64 6.32A7.36 7.36 0 00625 363c2.94.06 5.44-2.27 6.8-4.88 6.85-13.17 9.85-30.62 11.55-45.19 1.45-12.41.76-28.52 9.37-38.58 9-10.56 25.06-10.12 38.95-10.2 14.6-.07 33.69 5.4 47.42-1.3 20.15-9.85 28.84-41.35 54.91-37.62"
          strokeDasharray="1190.27 1191.69"
          strokeMiterlimit="7.11"
        />
        <path
          d="M.25 127.44c46.83-46.1 108.4-137.86 134.91 16 13.12 76.1 144.41 26.09 144.41 26.09 17.8 26.49 58.12 91.4 93 99.28 57.4 13 117-2.11 173.9-17.1 33.2-8.74 66.56-17.54 98-31.34 23.5-10.3 46.81-23.61 72.46-24.21 35.69-.84 41.35 27.39 77 28.89"
          strokeDasharray="964.74 966.16"
          strokeMiterlimit="7.11"
        />
        <path
          id="invisiblePath"
          d="M1366.25 225.25H952.19"
          strokeDasharray="431.14 432.57"
          strokeMiterlimit="7.11"
        />
      </g>
      <g id="unassigned-dots">
        <circle
          id="brain-dot"
          className="blue-circle"
          cx="975.94"
          cy="225.61"
          r="5.5"
        />
      </g>
      <g id="assigned-dots">
        <g id="dot-3">
          <circle className="blue-circle" cx="95.21" cy="376.98" r="5.5" />
          <text className="text-class" transform="translate(111.46 382.14)">
            Mediation
          </text>
        </g>
        <g id="dot-1">
          <circle className="blue-circle" cx="96.27" cy="60.57" r="5.5" />
          <text className="text-class" transform="translate(110.26 65.31)">
            Creative Leadership
          </text>
        </g>
        <g id="dot-9">
          <circle className="blue-circle" cx="642.12" cy="325.06" r="5.5" />
          <text className="text-class" transform="translate(659.18 330.14)">
            Offsites &amp; Retreats
          </text>
        </g>
        <g id="dot-2">
          <circle className="blue-circle" cx="70.83" cy="189.13" r="5.5" />
          <text className="text-class" transform="translate(86.94 193.13)">
            Facilitation
          </text>
        </g>
        <g id="dot-5">
          <circle className="blue-circle" cx="228.57" cy="150.53" r="5.5" />
          <text className="text-class" transform="translate(244.3 155.69)">
            Systems &amp; Team Coaching
          </text>
        </g>
        <g id="dot-4">
          <circle className="blue-circle" cx="217.59" cy="237.67" r="5.5" />
          <text className="text-class" transform="translate(183.59 261.1)">
            Performance
            <tspan x="0" y="15.6">
              Development
            </tspan>
          </text>
        </g>
        <g id="dot-7">
          <text className="text-class" transform="translate(495.89 192.77)">
            Agility Training
          </text>
          <circle className="blue-circle" cx="481.81" cy="188.13" r="5.5" />
        </g>
        <g id="dot-6">
          <text className="text-class" transform="translate(337.19 346.14)">
            Superior
            <tspan x="0" y="15.6">
              Virtual Engagements
            </tspan>
          </text>
          <circle className="blue-circle" cx="378.27" cy="310.21" r="5.5" />
        </g>
        <g id="dot-8">
          <text className="text-class" transform="translate(509.98 300.14)">
            Essential
            <tspan x="0" y="15.6">
              Conversations
            </tspan>
          </text>
          <circle className="blue-circle" cx="537.68" cy="274.29" r="5.5" />
        </g>
      </g>
    </Box>
  )
}

export default AnimateOne
